import React, { Component } from "react";
import InputField from "../../input-field/InputField";
import { validation } from "../primary-email-validation/PrimaryEmailValidation";

class Email extends Component {
  render() {
    const {
      id,
      name,
      placeholder,
      disabled,
      value
    } = this.props;

    return (
      <InputField
        id={id || "email"}
        name={name || "email"}
        type="email"
        placeholder={placeholder || "Email Address"}
        disabled={disabled}
        validation={validation}
        value={value}
      />
    );
  }
}

export default Email;
